import { Button, IButtonProps } from '@pinpointhq/thumbtack';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { scrollToFirstError } from '../../../utilities/scrollTo';

interface ISubmitButton extends Pick<IButtonProps, 'text' | 'fill' | 'buttonStyle' | 'disabled'> {
  id?: string;
  large?: boolean;
  loadingOverwrite?: boolean;
}

export default function ValidatingSubmitButton({
  large = true,
  loadingOverwrite,
  disabled = false,
  ...buttonProps
}: ISubmitButton) {
  const { isSubmitting, submitForm } = useFormikContext();

  function handleClick() {
    submitForm().then(() => {
      scrollToFirstError();
    });
  }

  return (
    <Button
      large={large}
      disabled={isSubmitting || disabled}
      loading={loadingOverwrite}
      onClick={handleClick}
      {...buttonProps}
    />
  );
}
